import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { submitContactApi } from '../api/allApi';

export const submitContact = createAsyncThunk(
    'contact/submitContact',
    async (payload, { rejectWithValue }) => {
        try {
            return await submitContactApi(payload);
        } catch (err) {
            return rejectWithValue(err?.response?.data?.message || 'Failed to submit contact');
        }
    }
);

const contactSlice = createSlice({
    name: 'contact',
    initialState: { submitLoading: false, success: false, error: null },
    reducers: {
        resetContactState: (state) => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(submitContact.pending, (state) => {
                state.submitLoading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(submitContact.fulfilled, (state) => {
                state.submitLoading = false;
                state.success = true;
            })
            .addCase(submitContact.rejected, (state, action) => {
                state.submitLoading = false;
                state.error = action.payload;
            });
    },
});

export const { resetContactState } = contactSlice.actions;
export default contactSlice.reducer;